import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AutosizeModule } from 'ngx-autosize';

import { MineosChatbotComponent } from './mineos-chatbot.component';
import { ContentPipeModule } from '../services/content/content-pipe.module';
import { MineChipComponent } from '../shared/mine-chip/mine-chip.component';

@NgModule({
  declarations: [
    MineosChatbotComponent
  ],
  imports: [
    CommonModule,
    AutosizeModule,
    ContentPipeModule,
    ReactiveFormsModule,
    MineChipComponent
  ],
  exports: [
    MineosChatbotComponent
  ],
})
export class MineosChatbotModule {}
